export default "__VITE_ASSET__0aYUDgFj__"